/* eslint-disable no-prototype-builtins */

import { formatEquipmentCallback } from './formatEquipmentCallback';
import { formatFurnitureCallback } from './formatFurnitureCallback';

function initiateReportProblemStep(reportProblem) {
  const reportProblemStep = {
    equipments: [],
    furnitures: []
  };

  if (!reportProblem) {
    return reportProblemStep;
  }

  if (!reportProblem.hasOwnProperty('equipments') || !reportProblem.hasOwnProperty('furnitures')) {
    throw new Error('Error: Lack object property');
  }

  const equipments = reportProblem.equipments.map(formatEquipmentCallback);
  const furnitures = reportProblem.furnitures.map(formatFurnitureCallback);

  return {
    equipments,
    furnitures
  };
}

export { initiateReportProblemStep };
